export const OTHER_OPTION_VALUE = "__other__";

export const DEPARTMENT_OPTIONS = [
  "Engineering",
  "QA",
  "DevOps",
  "HR",
  "Sales",
  "Finance",
  "Operations",
].map((value) => ({ value, label: value }));

export const DEMAND_LEVEL_OPTIONS = ["High", "Medium", "Low", "Critical"].map((value) => ({
  value,
  label: value,
}));

export const CLIENT_NOTICE_PERIOD_OPTIONS = [
  "Immediate",
  "15 days",
  "30 days",
  "45 days",
  "60 days",
  "90 days",
].map((value) => ({ value, label: value }));

export const HOLD_CLOSED_REASON_OPTIONS = [
  "Budget hold",
  "Role on hold",
  "Client paused",
  "Position filled",
  "No suitable profiles",
].map((value) => ({ value, label: value }));

export const MAJOR_SYSTEM_OPTIONS = [
  "IT",
  "Telecom",
  "Banking",
  "Healthcare",
  "ERP",
  "Cloud",
  "Retail",
].map((value) => ({ value, label: value }));

export const YES_NO_DISCUSS_OPTIONS = ["Yes", "No", "Under discussion"].map((value) => ({
  value,
  label: value,
}));

export const NEXT_ACTION_OPTIONS = [
  "Call candidate",
  "Schedule prep call",
  "Share with client",
  "Schedule client round",
  "Follow up client",
  "On hold",
  "Reject",
].map((value) => ({ value, label: value }));

export const PREP_FEEDBACK_OPTIONS = [
  "Good fit",
  "Average fit",
  "Not fit",
  "Not reachable",
  "Rescheduled",
].map((value) => ({ value, label: value }));

export const NOTICE_DAYS_PRESET_OPTIONS = ["0", "15", "30", "45", "60", "90", "120"].map((value) => ({
  value,
  label: value === "0" ? "0 days (Immediate)" : `${value} days`,
}));

export function splitStoredValue(value, options) {
  const normalized = String(value || "").trim();
  if (!normalized) return { select: "", other: "" };

  const match = options.find(
    (option) =>
      option.value.toLowerCase() === normalized.toLowerCase() ||
      option.label.toLowerCase() === normalized.toLowerCase()
  );
  if (match) return { select: match.value, other: "" };
  return { select: OTHER_OPTION_VALUE, other: normalized };
}

export function resolveStoredValue(select, other) {
  if (!select) return "";
  if (select === OTHER_OPTION_VALUE) return String(other || "").trim();
  return select;
}

export function buildDropdownFieldsFromValues(valuesByKey, optionsByKey) {
  const result = {};
  Object.entries(optionsByKey).forEach(([key, options]) => {
    result[key] = splitStoredValue(valuesByKey[key], options);
  });
  return result;
}

export function resolveDropdownFields(dropdownFields, keys) {
  const resolved = {};
  keys.forEach((key) => {
    const field = dropdownFields[key] || {};
    resolved[key] = resolveStoredValue(field.select, field.other);
  });
  return resolved;
}
